import { SBCRewardType } from "../api/privateRequests/sbcs/getSbcSets";

const PLAYER_PICK_ASSET = `${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fut23/misc/playerpick.png`;

export const extractRewardUrl = (reward?: SBCRewardType) => {
  if (!reward) {
    return "";
  }

  const defaultRewardImage = reward.rewardImgURL || reward.packImageURL || "";

  switch (reward.type) {
    case "playerpick":
      return PLAYER_PICK_ASSET;
    default:
      return defaultRewardImage;
  }
};
